import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-wizard-nav-catalog',
  templateUrl: './wizard-nav-catalog.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-nav-catalog.component.scss'],
  //host: {'class': 'app-wizard-answers-menu'},
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class WizardNavCatalogComponent extends WizardHpBaseComponent implements OnInit {
  @Input() catalog_index;
  @Input() simulateurComponent: SimulateurComponent;
  @Input() currentMenuProductStep:string;
  current_productSlug : any;
  current_productId  = -1;
  sideLoadProduct = false
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  // Preserve original property order
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.value.localeCompare(b.value);
  }

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }
  setCatalog(productId, productSlug,productKey,showStep_menu) 
  {
    let item = this.getHpService().getAllCataglog()[productKey]["catalogs"][0];
    this.getHpService().setCurrentProduct(productKey);
    this.sideLoadProduct = false;
    if(!showStep_menu && this.getHpService().getConfig().menu_expansionPanel)
    {
    this.getSimulateur().setCurrentProductIndex(0);
    this.getSimulateur().showElement(0);
    
    this.current_productId = productId;
    this.current_productSlug = productSlug;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
    return;
    }
    if(this.getHpService().getAllCataglog()[productKey]["catalogs"].length < 2 && item && showStep_menu)
    {
      this.getSimulateur().createProduct('aside-step-multi-menu',item.show_visual_menu,item,0,item.rootMenuProductStep);
      this.sideLoadProduct = true;
    }
    this.getHpService().setCurrentProductIndex(1); 
    this.current_productId = productId;
    this.current_productSlug = productSlug;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }

  /**
   *  Affichafe de la fenetre de dialogue pour la creation d'un nouveau produit
   * @param sideLoadProduct 
   */
  setSideLoadProduct(sideLoadProduct)
  {
    this.sideLoadProduct = sideLoadProduct;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }
}
